(function () {
  'use strict';

  function parseCounterValue(raw) {
    if (!raw) return null;
    var trimmed = raw.trim();
    if (!trimmed) return null;

    // Splits "+38%" -> prefix "+", number "38", suffix "%"
    // and "+6.5%" -> prefix "+", number "6.5", suffix "%"
    var match = trimmed.match(/^([^\d]*)(\d+(?:\.\d+)?)(.*)$/);
    if (!match) return null;

    var numberPart = match[2];
    var decimals = numberPart.indexOf('.') > -1 ? numberPart.split('.')[1].length : 0;

    return {
      prefix: match[1],
      value: parseFloat(numberPart),
      decimals: decimals,
      suffix: match[3]
    };
  }

  function animateNumber(el, target, decimals, reduceMotion) {
    if (reduceMotion) {
      el.textContent = target.toFixed(decimals);
      return;
    }

    var duration = 1400;
    var startTime = null;

    function step(timestamp) {
      if (!startTime) startTime = timestamp;
      var progress = Math.min((timestamp - startTime) / duration, 1);
      var eased = 1 - Math.pow(1 - progress, 3);
      el.textContent = (target * eased).toFixed(decimals);
      if (progress < 1) {
        window.requestAnimationFrame(step);
      } else {
        el.textContent = target.toFixed(decimals);
      }
    }
    window.requestAnimationFrame(step);
  }

  function setupCounters(root) {
    var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var counters = root.querySelectorAll('[data-nmn-counter]');

    counters.forEach(function (el) {
      var parsed = parseCounterValue(el.getAttribute('data-raw'));

      // No usable value (field left blank, or a connected dynamic source
      // resolved to nothing) — leave the element empty so the :empty CSS
      // rule hides it and the Heading field shows instead.
      if (!parsed) return;

      if (parsed.prefix) {
        var prefixSpan = document.createElement('span');
        prefixSpan.className = 'nmn-stats__value-affix';
        prefixSpan.textContent = parsed.prefix;
        el.appendChild(prefixSpan);
      }

      var numberSpan = document.createElement('span');
      numberSpan.className = 'nmn-stats__value-number';
      numberSpan.textContent = '0';
      el.appendChild(numberSpan);

      if (parsed.suffix) {
        var suffixSpan = document.createElement('span');
        suffixSpan.className = 'nmn-stats__value-affix';
        suffixSpan.textContent = parsed.suffix;
        el.appendChild(suffixSpan);
      }

      function run() {
        animateNumber(numberSpan, parsed.value, parsed.decimals, reduceMotion);
      }

      if ('IntersectionObserver' in window) {
        var observer = new IntersectionObserver(
          function (entries) {
            entries.forEach(function (entry) {
              if (entry.isIntersecting) {
                run();
                observer.unobserve(entry.target);
              }
            });
          },
          { threshold: 0.4 }
        );
        observer.observe(el);
      } else {
        run();
      }
    });
  }

  function openModal(modal) {
    modal.classList.add('is-open');
    document.body.classList.add('nmn-stats-lock-scroll');
    var closeBtn = modal.querySelector('.nmn-stats__modal-close');
    if (closeBtn) closeBtn.focus();
  }

  function closeModal(modal) {
    modal.classList.remove('is-open');
    document.body.classList.remove('nmn-stats-lock-scroll');
  }

  function setupPopups(root) {
    var cards = root.querySelectorAll('[data-nmn-card]');

    cards.forEach(function (card) {
      var targetId = card.getAttribute('data-modal-target');
      var modal = targetId ? root.querySelector('#' + targetId) : null;
      var img = modal ? modal.querySelector('img') : null;
      var src = img ? (img.getAttribute('src') || '').trim() : '';

      // The popup image setting resolved to nothing at runtime (whether it
      // was left blank or a connected metafield came back empty) — disable
      // the click affordance instead of trusting a liquid blank-check.
      if (!modal || !src) {
        card.removeAttribute('data-nmn-card');
        card.removeAttribute('tabindex');
        card.removeAttribute('role');
        card.removeAttribute('aria-haspopup');
        card.style.cursor = 'default';
        return;
      }

      card.addEventListener('click', function () {
        openModal(modal);
      });
      card.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          openModal(modal);
        }
      });
    });

    root.querySelectorAll('[data-nmn-modal]').forEach(function (modal) {
      var closeBtn = modal.querySelector('.nmn-stats__modal-close');
      if (closeBtn) {
        closeBtn.addEventListener('click', function () {
          closeModal(modal);
        });
      }
      modal.addEventListener('click', function (e) {
        if (e.target === modal) closeModal(modal);
      });
    });
  }

  function init() {
    document.querySelectorAll('.nmn-stats').forEach(function (root) {
      setupCounters(root);
      setupPopups(root);
    });

    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      document.querySelectorAll('.nmn-stats__modal.is-open').forEach(closeModal);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();